import { NumberScale } from 'legacy/lut/classes/models/partner360/NumberScale'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { getUrlPartnerId } from 'legacy/lut/helpers/getUrlPartnerId'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { ActualsValueTypes, DEFAULT_NETNDP } from 'partner360/models/actualValueTypes'

import { getUrlFYear } from './helpers/getUrlFYear'
import { getUrlProgramType } from './helpers/getUrlProgramType'
import { getUrlSummary } from './helpers/getUrlSummary'
import { IPartner360ConfigurationState } from './models/state'

const today = new Date()
export const initialState: IPartner360ConfigurationState = {
  data: {
    uid: '',
    entryId: 0,
    rtm: '',
    fYear: getUrlFYear() || today.getFullYear(),
    partnerId: getUrlPartnerId(),
    partnerName: '',
    locationId: '',
    partnerType: '',
    programOfferings: [],
    programTypes: [],
    programTypesExtended: [],
    programOfferingsCatalog: [],
    profiles: [],
    profilesJson: [],
    p360Profiles: [],
    amplifyTrack: '',
    country: '',
    geoMarket: null,
    geoMarketShort: null,
    geoRegion: null,
    deadlineSettings: null,
    keyInitiativesPending: [],
    outOfScope: false,

    pbmHeaderKey: '',
    pbmTooltipKey: '',
    managerHeaderKey: '',
    managerTooltipKey: '',
    partnerHeaderKey: '',
    partnerTooltipKey: '',

    dataInsight: {
      dataInsightFilename: '',
      dataInsightFilenamePptx: '',
      dataInsightHPLink: '',
      dataInsightHP2Link: '',
      dataInsightId: '',
      dataInsightPartnerLink: '',
    },

    files: {
      exportedFile: null,
      exportedFileCorePrint: null,
      exportedFileRetail: null,
      exportedFilePersonalSystemsSoftware: null,
      exportedFileMPS: null,
      exportedFileLargeFormat: null,
      exportedFileGeneral: null,
      exportedFileDistributor: null,
      exportedFileDaaS: null,
    },

    currencyData: {
      localCurrency: 'USD',
      defaultCurrency: '',
      actualsMultiCurrency: null,
    },

    actualsData: {
      valueTypeDefault: ActualsValueTypes.None,
      valueTypes: [],
    },

    actualsDate: null,

    actualsFromSellTo: null,

    salesTypes: [],

    partnerAccess: {
      isMPS: false,
      isMIF: false,
      isGlobal: false,
      isHybrid: false,
      isCommercial: false,
      isRetail: false,
      isDistributor: false,
      isRegionalDistributor: false,
      isPower: false,
      isPowerElite: false,
      isPowerEliteGlobal: false,
      isMasterDealer: false,
    },

    masterDealer: {
      masterDealerOfferings: [],
    },

    planning: {
      isBpsCategoryActive: false,
      isCorePrintContractualPlanningActive: false,
    },

    isTopPartner: false,
    isWWTopPartner: false,
    isMarketTopPartner: false,
    topPartnerInfo: '',
    isStrategicServicePartner: false,
    strategicServicePartnerInfo: '',
    isInitializationRequired: false,
    isIMPSServiceDelivery: null,

    pyActuals: null,
    cyPlans: null,
  },

  isNewOfferings: true,
  moneyScale: NumberScale.Thousands,
  programType: getUrlSummary() ? ProgramTypes.Summary : getUrlProgramType(),
  currency: 'USD',
  availableCurrencies: [],
  saleType: null,
  actualsType: DEFAULT_NETNDP,
  availableActualsTypes: [],
  status: RequestStatus.NONE,
  message: '',
}
